import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import { Modal, Toastr, Loader } from "arv-reactcomponents";

import { ToCurrency } from "../../../utils";
import { Checkout, PRICINGOVERVIEW } from "npmlinks-constants";

const { CHECKOUT_MESSAGES, DELIVERY_CHARGES } = Checkout;

@inject("CheckoutStore")
@observer
class SubPricingOverview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      deliveryCharges: this.props.CheckoutStore.deliveryCharges || [],
      loader: false
    };

    this.handleModal = this.handleModal.bind(this);
    this.handleDeliveryInfoClick = this.handleDeliveryInfoClick.bind(this);
  }

  handleModal() {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
      loader: false
    });
  }

  handleDeliveryInfoClick() {
    const { deliveryCharges } = this.state;
    if (deliveryCharges.length) {
      return this.setState({
        isModalOpen: !this.state.isModalOpen,
        loader: false
      });
    }
    this.setState({
      isModalOpen: !this.state.isModalOpen,
      loader: !this.state.loader
    });

    this.props.CheckoutStore.getDeliveryCharges().then(
      response => {
        this.setState({
          loader: !this.state.loader,
          deliveryCharges: response
        });
      },
      error => {
        this.setState({
          loader: false,
          isModalOpen: false
        });
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: CHECKOUT_MESSAGES.ERROR_MESSAGE,
          timeout: 3000
        });
      }
    );
  }

  get deliveryChargesData() {
    const { deliveryCharges } = this.state;
    if (deliveryCharges && deliveryCharges.length) {
      return (
        <ol className="nw-pricing-deliverycharges-listcontainer">
          {deliveryCharges.map(data => (
            <li className="nw-pricing-delivercharges-list">
              {data.mainText}
              {data.secondaryText && data.secondaryText.length
                ? data.secondaryText.map(item => (
                    <div className="nw-pricing-deliverycharges-secondarylist">
                      {item}
                    </div>
                  ))
                : null}
            </li>
          ))}
        </ol>
      );
    }
  }

  render() {
    const { isModalOpen, loader } = this.state;
    const deliveryChargesLink =
      process.env.REACT_APP_SHOWDELIVERY_CHARGES_LINK ||
      PRICINGOVERVIEW.DELIVERY_CHARGES_LINK;
    const {
      titleKey,
      value,
      currency,
      className = "",
      showDeliveryCharges
    } = this.props;
    return (
      <div key={titleKey} className={`${className} nw-pricing-unit`}>
        {titleKey === DELIVERY_CHARGES.TITLE &&
        (showDeliveryCharges === "true" || showDeliveryCharges === "link") ? (
          <span>
            {titleKey}
            {(showDeliveryCharges === "link" && (
              <a href={deliveryChargesLink} target="_blank">
                <i
                  className="nw-pricing-deliverycharges icomoon-notification"
                  role="presentation"
                />
              </a>
            )) || (
              <i
                className="nw-pricing-deliverycharges icomoon-notification"
                onClick={() => this.handleDeliveryInfoClick()}
                role="presentation"
              />
            )}
          </span>
        ) : (
          <span>{titleKey}</span>
        )}
        <span>{ToCurrency(value, currency)}</span>
        <Modal isOpen={isModalOpen} onClose={this.handleModal}>
          <h3 className="nw-pricing-delivercharges-title">
            {DELIVERY_CHARGES.TITLE}
          </h3>
          {loader ? (
            <Loader className="nw-bodyoverlay-loadercontainer" />
          ) : (
            this.deliveryChargesData
          )}
        </Modal>
      </div>
    );
  }
}

SubPricingOverview.propTypes = {
  titleKey: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  showDeliveryCharges: PropTypes.bool.isRequired,
  CheckoutStore: PropTypes.shape({
    getDeliveryCharges: PropTypes.func.isRequired,
    deliveryCharges: PropTypes.shape({}).isRequired
  }).isRequired
};

const getFinalComponent = component =>
  inject("CheckoutStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: SubPricingOverview.wrappedComponent,
  component: SubPricingOverview
};

export default ProjectComponent;